import React from 'react'
import LanguageMultiSelect from './LanguageMultiSelect'
import ValidationErrorText from '../common/ValidationErrorText'

const languageList = [
    { label: "English", group: "Recent Used Languages" },
    { label: "Hindi", group: "Recent Used Languages" },
    { label: "Tamil", group: "Recent Used Languages" },
    { label: "Malayalam", group: "Recent Used Languages" },
    { label: "Punjabi", group: "Recent Used Languages" },
    { label: "Urdu", group: "Recent Used Languages" },
    { label: "Sanskrit", group: "Recent Used Languages" },
    { label: "Turkish", group: "Global Languages" },
    { label: "Japanese (Kanji)", group: "Global Languages" },
    { label: "Italian", group: "Global Languages" },
    { label: "Portuguese", group: "Global Languages" },
]

const LanguageOfInstruction = ({ value, onChange, readOnly = false,fieldError }) => {
    return (
        <>
        <LanguageMultiSelect
            label="Language of Instruction"
            placeholder="Select language(s)"
            options={languageList}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
            groupBy={(option) => option.group}
        />
        <ValidationErrorText error={fieldError}/>
        </>
    )
}

export default LanguageOfInstruction
